import React, {useMemo} from 'react';
import LoadingBanner from "../../components/LoadingBanner";
import {NavLink, Outlet, useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {useClient} from "../../providers/ClientProvider";
const SupplierPortal = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const {auth, logout} = useAuth();
    const clientOrg = useClient();

    if (!auth) {
        return <div className="supplier-portal-container">
            <LoadingBanner/>
        </div>
    }

    const navLinks = useMemo(() => {
        return [
            {label: 'Projects', path: 'projects/all', isDisabled: false},
            {label: 'Contracts', path: 'contracts', isDisabled: false},
            {label: 'Jobs', path: 'job-board', active: 'job-board'},
            {label: 'Teams', path: 'teams', active: 'teams', isDisabled: !clientOrg.total_supplied_team_talent_users},
        ]
    }, [auth]);

    return (
        <div className="flex flex-col items-stretch min-h-fit flex-grow">

            <div className="nav-container p-0">
                <div className="nav-info mx-0 self-stretch block md:flex">

                    <NavLink to="dashboard"
                             className="bg-primary self-stretch mr-2 flex-col items-center justify-center gap-3 px-2 hidden md:flex">
                        {({isActive}) => (
                            <React.Fragment>
                                <i className="fa fa-th text-lg text-white"/>
                                <p className={isActive ? "text-white mb-0" : "hover:underline focus:underline transition-all text-white mb-0"}>
                                    Dashboard
                                </p>
                            </React.Fragment>
                        )}
                    </NavLink>

                    <div className="pt-2.5 pb-2 text-center md:pl-4">
                        <p className="text-white text-xl">Seller Portal</p>
                    </div>

                    <div className="mx-auto max-w-[400px] flex-grow items-center justify-between flex flex-row flex-nowrap">

                        {navLinks.map(({label, path, active, isDisabled}) => (
                            <NavLink key={`nav-${label}`}
                                     to={path}
                                     onClick={e => {
                                         if (isDisabled) e.preventDefault();
                                     }}
                                     className={({isActive}) => {
                                         let linkClass = isActive ? "font-semibold text-white underline" : "hover:underline focus:underline transition-all font-semibold text-white";
                                         if (isDisabled) {
                                             linkClass += ' opacity-60 cursor-not-allowed'
                                         }
                                         return linkClass;
                                     }}>
                                {label}
                            </NavLink>
                        ))}

                    </div>

                    <div className="mx-3 self-center hidden md:flex">
                        <button type="button" onClick={logout} className="min-w-[100px] btn btn-outline-light">
                            Log out
                        </button>
                    </div>
                </div>
            </div>

            <div className="flex-grow flex flex-col items-stretch">
                <Outlet/>
            </div>
        </div>
    );
}

export default SupplierPortal;